module.exports = __webpack_public_path__ + "img/slide-images-03.a3c8d599.jpg";